<template>
  <!-- eslint-disable -->
  <component :is="baseElement" v-if="isSanitized" v-html="sanitizedHtml" />
  <!-- eslint-enable -->
</template>

<script>
import sanitizeHtml from "sanitize-html";

export default {
  name: "SanitizeHtml",
  props: {
    dirty: {
      type: [String, Object],
      default: undefined,
    },
    baseElement: {
      type: String,
      default: "div",
    },
    dirtyFallback: {
      type: Boolean,
      default: false,
    },
    allowedTags: {
      type: Array,
      default: () => [
        "address",
        "article",
        "aside",
        "footer",
        "header",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "hgroup",
        "main",
        "nav",
        "section",
        "blockquote",
        "dd",
        "div",
        "dl",
        "dt",
        "figcaption",
        "figure",
        "hr",
        "li",
        "main",
        "ol",
        "p",
        "pre",
        "ul",
        "a",
        "abbr",
        "b",
        "bdi",
        "bdo",
        "br",
        "cite",
        "code",
        "data",
        "dfn",
        "em",
        "i",
        "kbd",
        "mark",
        "q",
        "rb",
        "rp",
        "rt",
        "rtc",
        "ruby",
        "s",
        "samp",
        "small",
        "span",
        "strong",
        "sub",
        "sup",
        "time",
        "u",
        "var",
        "wbr",
        "caption",
        "col",
        "colgroup",
        "table",
        "tbody",
        "td",
        "tfoot",
        "th",
        "thead",
        "tr",
      ],
    },
    disallowedTagsMode: { type: String, default: "discard" },
    allowedAttributes: {
      type: Object,
      default: () => ( {
        a: ["href", "name", "target"],
        img: ["src", "srcset"],
      } ),
    },
    allowedClasses: {
      type: Object,
      default: () => ( {} ),
    },
    selfClosing: {
      type: Array,
      default: () => ["img", "br", "hr", "area", "base", "basefont", "input", "link", "meta"],
    },
    allowedSchemes: {
      type: Array,
      default: () => ["http", "https" /* ,"ftp" */, "mailto", "tel"],
    },
    allowedSchemesByTag: {
      type: Object,
      default: () => ( {} ),
    },
    allowedSchemesAppliedToAttributes: { type: Array, default: () => ["href", "src", "cite"] },
    allowProtocolRelative: { type: Boolean, default: true },
    enforceHtmlBoundary: { type: Boolean, default: false },
    nestingLimit: {
      type: Number,
      default: 6,
    },
  },
  data: () => ( {
    defaultAllowedClasses: {
      // ensure any Umbraco rte custom classes are included here
      "*": [
        "rte__hyperlink",
        "rte__hyperlink--alt",
        "font-weight-light",
        "font-weight-normal",
        "font-weight-bold",
        "text-decoration-none",
      ],
    },
  } ),
  computed: {
    allowedStyleClasses () {
      return { ...this.allowedClasses, ...this.defaultAllowedClasses };
    },
    sanitizedHtml () {
      let result;

      if ( this.dirty ) {
        try {
          result = sanitizeHtml( this.dirty, {
            allowedTags: this.allowedTags,
            disallowedTagsMode: this.disallowedTagsMode,
            allowedAttributes: this.allowedAttributes,
            allowedClasses: this.allowedStyleClasses,
            selfClosing: this.selfClosing,
            allowedSchemes: this.allowedSchemes,
            allowedSchemesByTag: this.allowedSchemesByTag,
            allowedSchemesAppliedToAttributes: this.allowedSchemesAppliedToAttributes,
            allowProtocolRelative: this.allowProtocolRelative,
            enforceHtmlBoundary: this.enforceHtmlBoundary,
            nestingLimit: this.nestingLimit,
          } );
        } catch ( ex ) {
          this.logWarning();

          result = this.dirtyFallback
            ? this.dirty
            : "<p style=\"color: red\">Ommitted content due to security issues. Please contact your adminstrator</p>";
        }
      }
      return result;
    },
    isSanitized () {
      let result;

      if ( this.dirty == null || this.dirty === "" || this.sanitizedHtml ) {
        result = true;
      } else {
        result = false;
        this.logWarning();
      }
      return result;
    },
  },
  methods: {
    logWarning ( warning = "Security Vulnerability: Injected HTML has not been sanitized" ) {
      console.warn( warning );
    },
  },
};
</script>
